import React, { useCallback, useEffect, useMemo, useRef } from "react"
import { RiArrowDownLine, RiArrowUpLine } from "react-icons/ri"
import { useMediaQuery } from "react-responsive"
import { useTable, useSortBy, useBlockLayout } from "react-table"
import { VariableSizeList } from "react-window"
import { useWindowResize } from "../../core/utils/hooks/windowResize"
import { EmptyScreen } from "../Empty"
import { LoadingWithLabel } from "../Loading"
import { useSelector } from "react-redux"

import "./styles.scss"
const checkbox = (selected, setSelected, data, toggleRow, toggleSelectAll, keyCompare) => ({
  id: "checkbox",
  accessor: "",
  Header: "Todos",
  Cell: ({ row }) => {
    const original = row.original || {}
    return (
      <input
        type="checkbox"
        className="checkbox"
        checked={
          selected &&
          selected.length &&
          selected.find((item) => item && original && item[keyCompare] === original[keyCompare])
        }
        onChange={() => {
          toggleRow(original)
          // setSelected(prev => (original === prev ? "" : original));
        }}
      />
    )
  },
  Header: (x) => {
    return (
      <>
        <input
          type="checkbox"
          className="checkbox"
          checked={selected && selected.length > 1 && selected.length === data.length}
          onChange={() => toggleSelectAll()}
        />
      </>
    )
  },
  sortable: false,
  width: 45,
})

const ReactTableContainer = ({
  selecteds,
  columns,
  data,
  canSelect,
  onSelect,
  rowColor,
  height,
  className,
  loadingTable,
  keyCompare = "id",
  widthSetted = null,
}) => {
  const isCollapsed = useSelector((state) => state?.app.isCollapsed) || false

  const toggleAll = () => {
    onSelect(data)
  }

  const toggleRow = (original) => {
    onSelect(original)
  }

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, totalColumnsWidth } =
    useTable(
      {
        columns: useMemo(
          () =>
            canSelect
              ? [checkbox(selecteds, onSelect, data, toggleRow, toggleAll, keyCompare)].concat(
                  columns,
                )
              : columns,
          [selecteds, data, canSelect, columns, data, onSelect],
        ),
        data,
        autoResetSelectedRows: false,
        autoResetSelectedCell: false,
        autoResetSelectedColumn: false,
      },
      useSortBy,
      useBlockLayout,
    )

  const Row = ({ index, style, setSize, windowWidth, rowColor }) => {
    const rowRef = useRef()
    const row = rows[index]

    prepareRow(row)

    useEffect(() => {
      setSize(index, rowRef.current.getBoundingClientRect().height)
    }, [setSize, index, windowWidth])

    return (
      <>
        <div
          ref={rowRef}
          style={style}
          key={index}
          className={`table-tr${rowColor ? " table-tr--" + rowColor : ""}`}
          style={isCollapsed ? { width: "auto !important" } : {}}>
          {row.cells.map((cell, index) => {
            if (cell.column?.Header === "Tags") {
              let tags = cell.row?.original?.tag_user || cell.row?.original?.tags || []
              tags = tags.map((item) => item?.name).filter((item) => item)
            }

            return (
              <div
                {...cell.getCellProps({
                  style: { minWidth: cell.column.width, width: cell.column.width },
                })}
                key={index}
                data-label={cell.column.Header}
                className="table-tr-td td">
                {cell.render("Cell")}
              </div>
            )
          })}
        </div>
      </>
    )
  }

  const listRef = useRef()
  const sizeMap = useRef({})
  const setSize = useCallback((index, size) => {
    sizeMap.current = { ...sizeMap.current, [index]: size }
    listRef.current.resetAfterIndex(index)
  }, [])
  const getSize = (index) => sizeMap.current[index] || 110
  const [windowWidth] = useWindowResize()

  const generateHeaderStyles = (column) => {
    return {
      style: {
        minWidth: column.width,
        width: column.width,
      },
    }
  }

  const combinedHeaderProps = (defaultHeaderProps, { column }) => {
    return [defaultHeaderProps, generateHeaderStyles(column), column.getSortByToggleProps()]
  }

  const S = useMediaQuery({ query: "(max-height:768px)" })
  const tablet = useMediaQuery({ query: "(min-width: 768px) and (max-width: 1919px)" })

  return (
    <>
      {loadingTable ? (
        <LoadingWithLabel
          labelLoading="Aguarde, estamos atualizando as informações..."
          sizeSpinner="large"
          colorSpinner="primary"
        />
      ) : data.length > 0 ? (
        <div {...getTableProps()} className={`table${className ? " " + className : ""}`}>
          <div {...getTableBodyProps()} className="table-body" style={{ flex: "1 1 auto" }}>
            <div className="thead" role="thead">
              {headerGroups.map((headerGroup, index) => (
                <div
                  {...headerGroup.getHeaderGroupProps()}
                  key={index}
                  role="tr"
                  className="thead-tr tr">
                  {headerGroup.headers.map((column, index) => (
                    <div
                      key={index}
                      className="thead-th th"
                      {...column.getHeaderProps(combinedHeaderProps)}>
                      {column.render("Header")}

                      {column.isSorted ? (
                        column.isSortedDesc ? (
                          <RiArrowDownLine />
                        ) : (
                          <RiArrowUpLine />
                        )
                      ) : (
                        ""
                      )}
                    </div>
                  ))}
                </div>
              ))}
            </div>
            <VariableSizeList
              ref={listRef}
              height={S ? 450 : 600}
              itemCount={rows.length}
              itemSize={() => (S && height ? height : S && 120) || 100}
              width={
                windowWidth <= 768
                  ? windowWidth
                  : tablet
                  ? totalColumnsWidth + 25
                  : widthSetted
                  ? widthSetted
                  : windowWidth - 130
              }
              itemData={rows}
              className="user-table">
              {({ data, index, style }) => (
                <div style={style} className="table-rows">
                  <Row
                    data={data}
                    rowColor={rowColor}
                    index={index}
                    setSize={setSize}
                    windowWidth={tablet ? totalColumnsWidth + 25 : windowWidth - 130}
                  />
                </div>
              )}
            </VariableSizeList>
          </div>
        </div>
      ) : (
        <EmptyScreen label="Não encontramos dados" />
      )}
    </>
  )
}

export default ReactTableContainer
